<template>
  <div class="space-y-4">
      <label class="block text-sm font-semibold text-gray-900">{{ $t('Buy now') }}</label>

        <ProductVariantSummary
        class="max-w-xs"
          v-if="variantSelected"
          :summary="variantSelected.summary"
        />
          

        <PriceCompare  v-if="variantSelected" :price="variantSelected.price" :oldPrice="variantSelected.regularPrice" />

      <div class="flex gap-4">

      <QuantityInput 
        v-model="quantity"
        :max="variantSelected?.stock || 1"
      />

      <UButton 
        block 
        size="lg" 
        :disabled="!canAddToCart"
        @click="addToCart"
      >
        <Icon name="i-heroicons-shopping-cart" class="w-5 h-5 mr-2" />
        {{ $t('Add to cart') }}
      </UButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { useCartStore } from '~/stores/useCartStore'
import QuantityInput from '~/components/molecules/QuantityInput.vue'
import type { Product, ProductVariant } from '~/types';
import ProductVariantSummary from '~/components/molecules/ProductVariantSummary.vue'
import PriceCompare from './PriceCompare.vue';

const props = defineProps<{
  product: Product,
  variantSelected: ProductVariant | null
}>()

const emit = defineEmits<{
  (e: 'size-guide'): void
}>()

const cartStore = useCartStore()
const addedToCartModalStore = useAddToCartModal()

const quantity = ref(1)

const canAddToCart = computed(() => {
  if (!props.product.variants.length) return true
  return props.variantSelected && props.variantSelected.stock > 0
})

function addToCart() {
  if (canAddToCart.value && props.variantSelected) {
    cartStore.addProduct({ productId: props.product.id, quantity: quantity.value, variantId: props.variantSelected.id })

    addedToCartModalStore.show({
      product: props.product,
      variant: props.variantSelected,
      quantity: quantity.value
    })
  }
}
</script>
